import React from 'react'
import topBanner from '../Assets/img/topBanner.png';
import NewOrderDashboard from '../JuiceDashboard/NewOrderDashboard';
import { Link, NavLink, Outlet, json } from "react-router-dom";
const Home = () => {

  setTimeout(function () {
    const checkUserType = localStorage.getItem('userType');
    if (checkUserType == 'BPUser') {
      window.location.replace("/BPUDashboard/BPUDashContent");
    }
  }, 100);

  return (
    <>
      <div className='row'>
        <div className='col-md-12'>

          <Link to={`/ShareObservations`} className='btn btn-success btn-sm'>
            <img src={topBanner} className="img-rounded img-responsive" alt='Click Here to Book Tele Consulting Appointment' style={{ width: '100%' }} />
          </Link>
        </div>
      </div>
      <NewOrderDashboard />

      <div className='row'>

      </div>

    </>
  )
}

export default Home